const ProductTabsCollection = () => {
  const PRODUCT_CARD_SELECTOR = '.js-product-card';
  const TAB_SELECTOR = '.js-product-tabs-tab[data-collection-handle]';
  const LIMIT = 4;

  function shuffle(array) {
    const arr = [...array];
    for (let i = arr.length - 1; i > 0; i--) {
      const j = Math.floor(Math.random() * (i + 1));
      [arr[i], arr[j]] = [arr[j], arr[i]];
    }
    return arr;
  }

  async function fetchCollectionProducts(handle) {
    try {
      const res = await fetch(`${window.location.origin}/collections/${handle}/products.json?limit=250`);
      if (!res.ok) return [];
      const { products } = await res.json();
      return products || [];
    } catch {
      return [];
    }
  }

  async function fetchProductCard(handle) {
    try {
      const res = await fetch(`${window.location.origin}/products/${handle}?view=card`);
      if (!res.ok) return null;
      const text = await res.text();
      const div = document.createElement('div');
      div.innerHTML = text;
      return div.querySelector(PRODUCT_CARD_SELECTOR);
    } catch {
      return null;
    }
  }

  async function loadTab(tab) {
    const handle = tab.dataset.collectionHandle;
    if (!handle) return;

    const products = await fetchCollectionProducts(handle);
    const available = products.filter(p => p.variants.some(v => v.available));
    const selected = shuffle(available).slice(0, LIMIT);

    if (!selected.length) {
      tab.classList.remove('is-loading');
      return;
    }

    const cards = (await Promise.all(selected.map(p => fetchProductCard(p.handle)))).filter(Boolean);

    if (!cards.length) {
      tab.classList.remove('is-loading');
      return;
    }

    const wrapper = tab.querySelector('.product-tabs__tab-content.swiper-wrapper');
    if (!wrapper) return;

    wrapper.innerHTML = '';
    cards.forEach(card => {
      const slide = document.createElement('div');
      slide.className = 'product-tabs__product swiper-slide';
      slide.appendChild(card);
      wrapper.appendChild(slide);
    });

    const swiperEl = tab.querySelector('.swiper');
    if (swiperEl && swiperEl.swiper) {
      swiperEl.swiper.update();
    }

    tab.classList.remove('is-loading');
  }

  async function init() {
    const tabs = [...document.querySelectorAll(TAB_SELECTOR)];
    if (!tabs.length) return;
    await Promise.all(tabs.map(loadTab));
    window.themeCore?.LazyLoadImages?.init();
    window.themeCore?.EventBus?.emit('compare-products:init');
  }

  return Object.freeze({ init });
};

const action = () => {
  const instance = ProductTabsCollection();
  instance.init();
};

if (window.themeCore && window.themeCore.loaded) {
  action();
} else {
  document.addEventListener('theme:all:loaded', action, { once: true });
}
